import React, { useEffect, useMemo } from 'react';
import './ValItem.scss';
import { ValidateError } from 'async-validator';
import { ValidationErrorIcon } from '@icons';
import ReactTooltip from 'react-tooltip';

interface ValItemProps {
	validationMessages: ValidateError[]
}

function ValItem(props: ValItemProps): JSX.Element {
	const {
        validationMessages
	} = props;

	const labelView = useMemo((): JSX.Element => {
		const valMessages = validationMessages && validationMessages.map(m => m.message).join(".<br/>");
		const valClass = valMessages ? "val-message" : "val-message__hidden";
        return <span className={valClass} data-tip={valMessages}><ValidationErrorIcon /></span>;
		
	}, [validationMessages]);

	useEffect(()=>{
        ReactTooltip.rebuild();
    }, [validationMessages]);


	return labelView;
}

const MemoisedValItem = React.memo(ValItem);

export {MemoisedValItem as ValItem};